import React from "react";
import { useAuth } from "../../context/AuthContext";
import { isBriterBridgesUser } from "../../utils/strings";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute component - simplified wrapper for authenticated routes
 *
 * Route selection is now handled at the top level (index.tsx) based on persona.
 * This component just ensures the user is loaded and passes through children.
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user } = useAuth();

  // If user is not loaded yet, show children (loading will be handled by AuthContext)
  if (!user) {
    return <>{children}</>;
  }

  // User is authenticated, render children
  return <>{children}</>;
};

/**
 * Utility function to check if a user can access a specific route
 * @deprecated Route access is now handled by persona-based routing in index.tsx
 */
export const canAccessRoute = (
  path: string,
  userType?: string,
  userEmail?: string,
): boolean => {
  // BriterBridges.com users can access everything
  if (isBriterBridgesUser(userEmail)) {
    return true;
  }

  // All authenticated users can access all routes
  // (persona-specific routing is handled at the router level)
  return true;
};

/**
 * Get the default redirect path based on user type and email
 * @deprecated Default redirects are now handled by persona-based routing in index.tsx
 */
export const getDefaultRedirectPath = (
  userType?: string,
  userEmail?: string,
): string => {
  // Default to root - persona routing will handle the rest
  return "/";
};
